import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import Headers from './Header';
import NavigationBar from './Navigation';
import Loader from '../common/Loader';
import SessionType from '../common/SessionType';
import SessionStatusButton from '../common/SessionStatusButton';
import { showNotification } from '../../action/NotificationAction';
import { PATH } from '../../../utils/Constants';
import banner from '../../../utils/images/dashboardBanner.svg';
import { getAppointmentDetails, getDashboardDetails } from '../../action/educator/DashboardAction';
import { InPerson } from '../../../utils/common/NamingTerms';
import {
    getStudentEducator,
    getStudentEducatorSubcategory,
    getStudentEducatorSubject,
} from '../../action/student/DashboardAction';
import { RESPONSE_CONSTANT } from '../../../utils/ResponseConstant';
import { postOndemandAppointment } from '../../action/student/AppointmentAction';
import {
    // validateEmail,
    validateSearchInput,
} from '../../../utils/Utility';
import AppConfig from '../../../utils/common/DomainConfiguration';
import { LanguageProvider, useLanguage } from '../../../utils/common/LanguageContext';
// import store from "../../../sessionStorage";
// import Modal from "react-modal";
/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */

// HOC to inject language context into class component
const withLanguage = (Component) => {
    return (props) => {
        const { t } = useLanguage();
        return <Component {...props} t={t} />;
    };
};

class PatientDashBoard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileNav: false,
            tabName: 'ongoing',
            isLoading: false,
            isAppointmentLoading: false,
            sessionIndex: 0,
            educatorLoading: false,
            educatorReport: [],
            educatorCurrentPage: 1,
            educatorTotalPages: 1,
            searchValue: '',
            educatorId: '',
            subjectId: '',
            subcategoryId: '',
            subjectLoading: false,
            subjectReport: [],
            subcategoryReport: [],
            subjectCurrentPage: 1,
            subjectTotalPages: 1,
            enableButton: false,
            // userEmail: "",
            // isModalOpen: false,
            btnLoading: false,
        };
    }

    //componentDidMount
    componentDidMount() {
        // const userData = store.get("userSession") || {};
        // const modalState = sessionStorage.getItem("modalClosed");
        // if (userData.needToShowPopUp && !modalState) {
        //   this.setState({
        //     isModalOpen: true,
        //     profileEmail: userData.email || "",
        //     profileMobileNumber: userData.mobileNumber || "",
        //     userEmail: userData.email,
        //     userMobileNumber: userData.mobileNumber,
        //   });
        // }
        this.getStudentEducator();
    }

    // componentDidUpdate
    componentDidUpdate(prevProps) {
        if (this.props.deactivateUserScreen !== prevProps.deactivateUserScreen) {
            clearInterval(this.timer);
        }
    }

    // componentWillMount
    componentWillMount() {
        this.getDashboardDetails();
        this.getAppointmentDetails();
        this.timer = setInterval(() => {
            this.getAppointmentDetails();
        }, 30000);
    }

    // componentWillUnmount
    componentWillUnmount() {
        clearInterval(this.timer);
    }

    // getAppointmentDetails
    getAppointmentDetails = () => {
        this.setState({ isAppointmentLoading: true });
        this.props.getAppointmentDetails((result) => {
            this.setState({ isAppointmentLoading: false });
        });
    };

    // getDashboardDetails
    getDashboardDetails = () => {
        this.isLoading();
        this.props.getDashboardDetails((result) => {
            this.isLoading();
        });
    };

    //getStudentEducator
    getStudentEducator(search, pageNumber, itemsPerPage) {
        const values = {
            search,
            pageNumber: 1,
            itemsPerPage: 99999,
        };
        this.props.getStudentEducator(values, (result) => {
            if (result && result.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.setState({
                    educatorLoading: false,
                    educatorReport: result.response.data,
                    educatorCurrentPage: result.response.pageNumber,
                    educatorTotalPages: result.response.totalPages,
                });
            }
        });
    }

    //getStudentEducatorSubject
    getStudentEducatorSubject(id) {
        const values = {
            pageNumber: 1,
            itemsPerPage: 99999,
        };
        this.props.getStudentEducatorSubject(id, values, (result) => {
            if (result && result.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.setState({
                    subjectLoading: false,
                    subjectReport: result?.response?.data,
                    subjectCurrentPage: result.response.pageNumber,
                    subjectTotalPages: result.response.totalPages,
                });
            }
        });
    }

    //getStudentEducatorSubcategory
    getStudentEducatorSubcategory(educatorId, subjectId) {
        const values = {
            educatorId,
            subjectId,
            pageNumber: 1,
            itemsPerPage: 99999,
        };
        this.props.getStudentEducatorSubcategory(values, (result) => {
            if (result && result.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.setState({
                    subcategoryLoading: false,
                    subcategoryReport: result?.response?.data,
                    subcategoryCurrentPage: result.response.pageNumber,
                    subcategoryTotalPages: result.response.totalPages,
                });
            }
        });
    }

    //onClickMobileNav
    onClickMobileNav = (type) => {
        this.setState({ mobileNav: type });
    };

    //isLoading
    isLoading() {
        this.setState({ isLoading: !this.state.isLoading });
    }

    //handleSearchUser
    handleSearchUser = (event) => {
        const searchValue = event.target.value;
        if (validateSearchInput(searchValue) || searchValue === '') {
            this.setState({
                searchValue,
                subcategoryReport: [],
                subjectReport: [],
                enableButton: false,
            });
            clearTimeout(this.state.timeout);
            const educatorList = document.getElementById('educator-list');
            if (educatorList) {
                educatorList.scrollTop = 0;
            }
            const timeout = setTimeout(() => {
                this.getStudentEducator(this.state.searchValue, 0, 1000);
            }, 1000); // 1Sec delay before triggering the search
            this.setState({ timeout });
        }
    };

    // handleSubmitOnDemand
    handleSubmitOnDemand = () => {
        const userSession = JSON.parse(sessionStorage.getItem('userSession'));
        const sessionID = userSession.student.id;
        if (!this.state.educatorId) {
            this.props.showNotification(
                RESPONSE_CONSTANT.EDUCATOR_MANDATORY,
                RESPONSE_CONSTANT.WARNING
            );
            return;
        }
        if (!this.state.subjectId) {
            this.props.showNotification(
                RESPONSE_CONSTANT.SUBJECT_MANDATORY,
                RESPONSE_CONSTANT.WARNING
            );
            return;
        }
        this.setState({ isLoading: true });
        let data = {
            tutorId: this.state.educatorId,
            sessionDate: moment().format('YYYY-MM-DD'),
            expertiseCategoryId: this.state.subjectId,
            expertiseId: this.state.subcategoryId || null,
            gradeId: 13,
            studentId: sessionID,
            visitType: 1,
            topic: '',
            slotId: [],
            referenceFiles: [],
        };
        this.props.onDemandBook(data, (res) => {
            this.setState({ isLoading: false });
            if (res.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.props.showNotification(res.message, 'success');
                this.props.history.push(
                    `${PATH.IM_PATIENT.APPOINTMENT}/${this.props.match.params.userId}`
                );
            } else {
                this.props.showNotification(res.message, 'error');
            }
        });
    };

    // handleHideRemindMe = (lable) => {
    //   sessionStorage.setItem("modalClosed", true);
    //   this.setState({ isModalOpen: false });
    //   this.props.hideRemindMeLater({
    //     hideMessage: lable === "hide" ? true : false,
    //     remindMeLater: lable === "remind" ? true : false,
    //   });
    // };

    // submit = () => {
    //   this.setState({ btnLoading: true });
    //   const { profileEmail, profileMobileNumber } = this.state;
    //   if (
    //     profileMobileNumber &&
    //     profileMobileNumber !== this.state.userMobileNumber &&
    //     profileMobileNumber.length !== 10
    //   ) {
    //     this.props.showNotification(
    //       "Please enter valid mobile number",
    //       "warning"
    //     );
    //     this.setState({ btnLoading: false });
    //     return;
    //   }

    //   let values = {
    //     email: profileEmail,
    //     mobileNumber: profileMobileNumber,
    //   };
    //   if (profileEmail && profileEmail === this.state.userEmail) {
    //     values = { mobileNumber: profileMobileNumber };
    //   }
    //   if (
    //     profileMobileNumber &&
    //     profileMobileNumber === this.state.userMobileNumber
    //   ) {
    //     values = { email: profileEmail };
    //   }
    //   if (profileEmail && !validateEmail(profileEmail.trim())) {
    //     this.props.showNotification(
    //       RESPONSE_CONSTANT.INVALID_EMAIL,
    //       RESPONSE_CONSTANT.WARNING
    //     );
    //     return;
    //   }
    //   this.props.addUserContactInformation(values, (response) => {
    //     this.setState({ btnLoading: false });
    //     if (response && response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
    //       sessionStorage.setItem("modalClosed", true);
    //       this.setState({ isModalOpen: false });
    //       if (!values.email && !values.mobileNumber) {
    //         this.props.showNotification(
    //           "Please Enter The User Details",
    //           RESPONSE_CONSTANT.WARNING
    //         );
    //       } else {
    //         this.props.showNotification(
    //           response.message,
    //           RESPONSE_CONSTANT.SUCCESS
    //         );
    //       }
    //     } else {
    //       if (response.message) {
    //         this.props.showNotification(
    //           response.message,
    //           RESPONSE_CONSTANT.WARNING
    //         );
    //       }
    //     }
    //   });
    // };

    // closeCancelationModal = () => {
    //   this.setState({ isModalOpen: false });
    // };

    /**
     * Render page
     */
    render() {
        const { sessionIndex } = this.state;
        // const { isModalOpen, userEmail, userMobileNumber } = this.state;
        const { todaySession, previousSession, upcomingSession, userDetails } = this.props;
        return (
            <div className="fixed top-0 left-0 flex w-full h-full">
                <div
                    className={`bg-black bg-opacity-50 fixed top-0 left-0 w-full h-full z-10 ${
                        this.state.mobileNav ? 'block' : 'hidden'
                    }`}
                ></div>
                <NavigationBar
                    nav={true}
                    {...this.props}
                    active={PATH.IM_PATIENT.DASHBOARD}
                    mobileNav={this.state.mobileNav}
                    onClickMobileNav={this.onClickMobileNav}
                />
                <main className="flex flex-col flex-grow overflow-auto">
                    <Headers
                        {...this.props}
                        title={this.props.t('home')}
                        onClickMobileNav={this.onClickMobileNav}
                    />
                    <div className="flex flex-col w-full h-full py-8 overflow-auto bg-UIBackground">
                        {this.state.isLoading ? (
                            <Loader />
                        ) : (
                            <>
                                <div className="items-center justify-between px-4 sm:flex">
                                    <div className="w-full rounded-2xl sm:flex justify-between items-center bg-gradient-to-r from-[#58429a] via-[#3c305e] to-[#342a59]">
                                        <div className="p-4 sm:p-6">
                                            <h6
                                                className="mb-2 text-4xl font-medium text-white sm:text-3xl"
                                                title={`${userDetails.firstName} ${userDetails.lastName}`}
                                            >
                                                {this.props.t('hi')}{' '}
                                                {`${userDetails.firstName} ${userDetails.lastName}`}
                                                ,
                                            </h6>
                                            <p className="mb-0 text-white">
                                                {this.props.t('welcomeToBloomlink')}
                                            </p>
                                        </div>
                                        <div className="pe-1">
                                            <img src={banner} className="img-fluid" alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className="px-4 mt-6">
                                    <div className="flex flex-col gap-4 lg:flex-row">
                                        {/* <div className="flex flex-1 p-4 rounded-lg bg-card sm:mt-0 lg:w-2/4"> */}
                                        {/* <div className="w-full"> */}
                                        {/* <p className="mb-1 font-semibold text-white">
                          Book On-Demand Session
                        </p>
                        <div className="flex items-center justify-between">
                          <input
                            type="text"
                            onChange={this.handleSearchUser}
                            value={this.state.searchValue}
                            className="block w-full rounded bg-dateselect py-1.5 px-4 text-white placeholder:text-white sm:text-base sm:leading-6 lg:w-1/2"
                            placeholder="Search Owner"
                            autoComplete="off"
                            maxLength={50}
                          />
                        </div> */}
                                        {/* <div className="flex flex-col justify-between gap-2 mt-4 md:flex-row "> */}
                                        {/* <div className="flex flex-col justify-between w-full gap-2 overflow-auto overflow-y-hidden md:flex-row md:w-9/12 scrollbar-hidden"> */}
                                        {/* Educator Section */}
                                        {/* <div
                              id="educator-list"
                              className="w-full h-40 min-h-0 overflow-x-hidden overflow-y-auto md:w-2/5 sm:w-32"
                            >
                              <p className="sticky top-0 mb-1 font-semibold text-white">
                                Owner
                              </p>
                              <ul className="text-sm text-white">
                                {this.state.educatorReport.length === 0 ? (
                                  <p className="mt-8 mb-8 text-center">
                                    {RESPONSE_CONSTANT.TUTOR_UNAVAILABLE}
                                  </p>
                                ) : (
                                  this.state.educatorReport.map((educator) => (
                                    <li key={educator.id}>
                                      <p
                                        className={`block px-1 py-2 rounded cursor-pointer hover:bg-[#34373E] truncate ${
                                          this.state.educatorId ===
                                          educator.educatorId
                                            ? "bg-[#34373E] font-bold"
                                            : ""
                                        }`}
                                        onClick={() => {
                                          this.setState({
                                            subcategoryReport: [],
                                            subjectReport: [],
                                            educatorId: educator.educatorId,
                                            enableButton: false,
                                            subjectId: "",
                                            subcategoryId: "",
                                          });
                                          this.getStudentEducatorSubject(
                                            educator.educatorId
                                          );
                                        }}
                                        title={educator.name}
                                      >
                                        {educator.name}
                                      </p>
                                    </li>
                                  ))
                                )}
                              </ul>
                            </div> */}

                                        {/* Channel Section */}
                                        {/* <div className="w-full h-40 min-h-0 overflow-x-hidden overflow-y-auto md:w-2/6 sm:w-32">
                              <p className="mb-1 font-semibold text-white after:ml-0.5 sticky top-0">
                                Channel
                              </p>
                              <ul className="text-sm">
                                {this.state.subjectReport.map((subjects) => (
                                  <li key={subjects.id}>
                                    <p
                                      className={`block px-2 py-2 rounded hover:bg-gray-300 cursor-pointer truncate ${
                                        this.state.subjectId === subjects.id
                                          ? "bg-[#34373E] font-bold text-white"
                                          : "text-white"
                                      }`}
                                      onClick={() => {
                                        this.setState({
                                          subcategoryReport: [],
                                          enableButton: false,
                                          subjectId: subjects.id,
                                          subcategoryId: "",
                                        });
                                        this.getStudentEducatorSubcategory(
                                          this.state.educatorId,
                                          subjects.id
                                        );
                                      }}
                                      title={subjects?.name}
                                    >
                                      {subjects?.name}
                                    </p>
                                  </li>
                                ))}
                              </ul>
                            </div> */}

                                        {/* Subcategory Section */}
                                        {/* <div className="w-full h-40 min-h-0 overflow-x-hidden overflow-y-auto md:w-2/5 sm:w-32">
                              <p className="sticky top-0 mb-1 font-semibold text-white ">
                                Element
                              </p>
                              <ul className="text-sm">
                                {this.state.subcategoryReport.map(
                                  (subcategory) => (
                                    <li key={subcategory.id}>
                                      <p
                                        className={`block px-2 py-2 rounded hover:bg-gray-300 cursor-pointer truncate ${
                                          this.state.subcategoryId ===
                                          subcategory.id
                                            ? "bg-[#34373E] font-bold text-white"
                                            : "text-white"
                                        }`}
                                        onClick={() =>
                                          this.setState({
                                            enableButton: true,
                                            subcategoryId: subcategory.id,
                                          })
                                        }
                                        title={subcategory?.name}
                                      >
                                        {subcategory?.name}
                                      </p>
                                    </li>
                                  )
                                )}
                              </ul>
                            </div> */}
                                        {/* </div> */}

                                        {/* Button Section */}
                                        {/* <div className="flex items-center justify-center md:justify-end">
                            <button
                              className={`${
                                this.state.enableButton
                                  ? "text-white bg-UIprimary cursor-pointer"
                                  : "text-white border-white ring-1 ring-inset ring-white"
                              } px-3 py-1.5 rounded text-center font-medium whitespace-nowrap text-base sm:mt-0 mt-4`}
                              onClick={() => this.handleSubmitOnDemand()}
                            >
                              On Demand
                            </button>
                          </div> */}
                                        {/* </div> */}
                                        {/* </div> */}
                                        {/* </div> */}
                                        <div className="flex flex-1 p-4 rounded-lg bg-card lg:w-2/4">
                                            <div className="w-full">
                                                <p className="mb-1 font-semibold text-white">
                                                    {this.props.t('createSession')}
                                                </p>
                                                <p className="text-white">
                                                    {this.props.t(
                                                        'wouldYouLikeToCreateAppointment'
                                                    )}
                                                </p>
                                                <div className="my-4 border border-[#34373E]"></div>
                                                <div className="flex items-center justify-center md:justify-end py-14 sm:mt-14">
                                                    <button
                                                        className="bg-UIprimary px-5 py-1.5 rounded text-white font-medium whitespace-nowrap text-base sm:mt-0 mt-4"
                                                        onClick={() =>
                                                            this.props.history.push(
                                                                `${PATH.IM_PATIENT.APPOINTMENT}/${this.props.match.params.userId}/create`
                                                            )
                                                        }
                                                    >
                                                        {this.props.t('create')}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="p-4 mt-6 overflow-x-auto rounded-lg bg-card ">
                                        <nav className="flex flex-col gap-2 mb-6 border-b border-[#34373E] sm:flex-row">
                                            <button
                                                className={`text-lg p-3 block hover:text-UIprimary focus:outline-none ${
                                                    this.state.tabName === 'ongoing'
                                                        ? 'text-UIprimary border-b-2 font-medium text-base'
                                                        : 'text-UIsecondary font-medium'
                                                }`}
                                                onClick={() =>
                                                    this.setState({ tabName: 'ongoing' })
                                                }
                                            >
                                                {this.props.t('ongoingAppointments')}
                                            </button>
                                            <button
                                                className={`text-base p-3 block hover:text-UIprimary focus:outline-none ${
                                                    this.state.tabName === 'upcoming'
                                                        ? 'text-UIprimary border-b-2 font-medium text-base'
                                                        : 'text-UIsecondary font-medium'
                                                }`}
                                                onClick={() =>
                                                    this.setState({ tabName: 'upcoming' })
                                                }
                                            >
                                                {this.props.t('upcomingSessions')}
                                            </button>
                                            <button
                                                className={`text-base p-3 block hover:text-UIprimary focus:outline-none ${
                                                    this.state.tabName === 'recent'
                                                        ? 'text-UIprimary border-b-2 font-medium text-base'
                                                        : 'text-UIsecondary font-medium'
                                                }`}
                                                onClick={() => this.setState({ tabName: 'recent' })}
                                            >
                                                {this.props.t('recentSessions')}
                                            </button>
                                        </nav>
                                        <div id="myTabContent">
                                            {this.state.tabName === 'ongoing' ? (
                                                <div
                                                    className="overflow-x-auto"
                                                    id="ongoing"
                                                    role="tabpanel"
                                                    aria-labelledby="ongoing-tab"
                                                >
                                                    {todaySession && todaySession.length ? (
                                                        <>
                                                            <div className="w-full p-3 mb-6 overflow-auto rounded-lg  bg-card border-[#34373E] hover:bg-black/10 lg:overflow-hidden whitespace-nowrap">
                                                                <div className="sm:grid md:grid-cols-7 lg:gap-4 md:gap-24">
                                                                    <div>
                                                                        <p className="mb-1 text-sm text-white">
                                                                            {this.props.t(
                                                                                'sessionType'
                                                                            )}
                                                                        </p>
                                                                        <SessionType
                                                                            sessionType={
                                                                                todaySession[
                                                                                    sessionIndex
                                                                                ].sessionType
                                                                            }
                                                                            isFromDashboard={true}
                                                                            isFromDashboardAppointment={
                                                                                true
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        <p className="mb-1 text-sm text-white">
                                                                            {this.props.t(
                                                                                'ownerName'
                                                                            )}
                                                                        </p>
                                                                        <p
                                                                            className="mb-3 text-base font-normal truncate text-UInew sm:mb-0"
                                                                            title={
                                                                                todaySession[
                                                                                    sessionIndex
                                                                                ].educatorName
                                                                            }
                                                                        >
                                                                            {
                                                                                todaySession[
                                                                                    sessionIndex
                                                                                ].educatorName
                                                                            }
                                                                        </p>
                                                                    </div>
                                                                    <div>
                                                                        <p className="mb-1 text-sm text-white">
                                                                            {this.props.t('date')}
                                                                        </p>
                                                                        <p className="mb-3 text-base font-normal text-UInew sm:mb-0">
                                                                            {moment(
                                                                                todaySession[
                                                                                    sessionIndex
                                                                                ].sessionStartDate
                                                                            ).format(
                                                                                'MMM DD, YYYY'
                                                                            )}
                                                                        </p>
                                                                    </div>
                                                                    <div>
                                                                        <p className="mb-1 text-sm text-white">
                                                                            {this.props.t('time')}
                                                                        </p>
                                                                        <p className="mb-3 text-base font-normal text-UInew sm:mb-0">
                                                                            {moment(
                                                                                todaySession[
                                                                                    sessionIndex
                                                                                ].sessionStartDate
                                                                            ).format('hh:mm A')}
                                                                        </p>
                                                                    </div>
                                                                    <div>
                                                                        <p className="mb-1 text-sm text-white">
                                                                            {
                                                                                AppConfig.labels
                                                                                    .channelName
                                                                            }
                                                                        </p>
                                                                        <p className="mb-3 text-base font-normal truncate text-UInew sm:mb-0">
                                                                            {todaySession[
                                                                                sessionIndex
                                                                            ].subject
                                                                                ? todaySession[
                                                                                      sessionIndex
                                                                                  ].subject
                                                                                : RESPONSE_CONSTANT.NOT_ASSIGNED}
                                                                        </p>
                                                                    </div>
                                                                    <div>
                                                                        <p className="mb-1 text-sm text-white">
                                                                            {this.props.t(
                                                                                'element'
                                                                            )}
                                                                        </p>
                                                                        <p className="mb-3 text-base font-normal truncate text-UInew sm:mb-0">
                                                                            {todaySession[
                                                                                sessionIndex
                                                                            ].subCategory
                                                                                ? todaySession[
                                                                                      sessionIndex
                                                                                  ].subCategory
                                                                                : RESPONSE_CONSTANT.NOT_ASSIGNED}
                                                                        </p>
                                                                    </div>
                                                                    <div className="flex items-center justify-end mt-4 sm:mt-0 text-wrap">
                                                                        {todaySession[sessionIndex]
                                                                            .sessionType !==
                                                                            InPerson && (
                                                                            <div className="flex items-center">
                                                                                <button
                                                                                    className="px-5 py-1 font-medium text-white rounded-lg bg-UIprimary text-nowrap"
                                                                                    onClick={() => {
                                                                                        this.props.history.push(
                                                                                            `${PATH.IM_PATIENT.WAITINGROOM}/${this.props.match.params.userId}/${todaySession[sessionIndex].sessionId}`
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    {this.props.t(
                                                                                        'viewDetails'
                                                                                    )}
                                                                                </button>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <div className="flex items-center justify-center text-white">
                                                            {this.props.t('noAppointmentFound')}
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <>
                                                    {this.state.tabName === 'upcoming' ? (
                                                        <div
                                                            className="overflow-x-auto"
                                                            id="upcoming"
                                                            role="tabpanel"
                                                            aria-labelledby="upcoming-tab"
                                                        >
                                                            {upcomingSession &&
                                                            upcomingSession.length ? (
                                                                <>
                                                                    {upcomingSession.map(
                                                                        (session, index) => (
                                                                            <div
                                                                                className="w-full p-3 mb-6 overflow-auto rounded-lg  bg-card border-[#34373E] hover:bg-black/10 lg:overflow-hidden whitespace-nowrap"
                                                                                key={index}
                                                                            >
                                                                                <div className="sm:grid md:grid-cols-7 lg:gap-4 md:gap-24">
                                                                                    <div>
                                                                                        <p className="mb-1 text-sm text-white">
                                                                                            {this.props.t(
                                                                                                'sessionType'
                                                                                            )}
                                                                                        </p>
                                                                                        <SessionType
                                                                                            className="mb-3 truncate sm:mb-0 text-UInew"
                                                                                            sessionType={
                                                                                                session.sessionType
                                                                                            }
                                                                                            isFromDashboard={
                                                                                                true
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                    <div>
                                                                                        <p className="mb-1 text-sm text-white">
                                                                                            Owner
                                                                                            Name
                                                                                        </p>
                                                                                        <p
                                                                                            className="mb-3 text-base font-normal truncate text-UInew sm:mb-0"
                                                                                            title={
                                                                                                session.educatorName
                                                                                            }
                                                                                        >
                                                                                            {
                                                                                                session.educatorName
                                                                                            }
                                                                                        </p>
                                                                                    </div>
                                                                                    <div>
                                                                                        <p className="mb-1 text-sm text-white">
                                                                                            Date
                                                                                        </p>
                                                                                        <p className="mb-3 text-base font-normal text-UInew sm:mb-0">
                                                                                            {moment(
                                                                                                session.sessionStartDate
                                                                                            ).format(
                                                                                                'MMM DD, YYYY'
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div>
                                                                                        <p className="mb-1 text-sm text-white">
                                                                                            Time
                                                                                        </p>
                                                                                        <p className="mb-3 text-base font-normal text-UInew sm:mb-0">
                                                                                            {moment(
                                                                                                session.sessionStartDate
                                                                                            ).format(
                                                                                                'hh:mm A'
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div>
                                                                                        <p className="mb-1 text-sm text-white">
                                                                                            {
                                                                                                AppConfig
                                                                                                    .labels
                                                                                                    .channelName
                                                                                            }
                                                                                        </p>
                                                                                        <p className="mb-3 text-base font-normal truncate text-UInew sm:mb-0">
                                                                                            {session.subject
                                                                                                ? session.subject
                                                                                                : RESPONSE_CONSTANT.NOT_ASSIGNED}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div>
                                                                                        <p className="mb-1 text-sm text-white">
                                                                                            Element{' '}
                                                                                        </p>
                                                                                        <p className="mb-3 text-base font-normal truncate text-UInew sm:mb-0">
                                                                                            {session.subCategory
                                                                                                ? session.subCategory
                                                                                                : RESPONSE_CONSTANT.NOT_ASSIGNED}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="flex items-center justify-end mt-4 sm:mt-0 text-wrap">
                                                                                        <SessionStatusButton
                                                                                            className="w-full"
                                                                                            status={
                                                                                                session.sessionStatus
                                                                                            }
                                                                                            visitId={
                                                                                                session.sessionId
                                                                                            }
                                                                                            sessionType={
                                                                                                session.sessionType
                                                                                            }
                                                                                            navigateToDetailScreen={() => {
                                                                                                this.props.history.push(
                                                                                                    `${PATH.IM_PATIENT.WAITINGROOM}/${this.props.match.params.userId}/${session.sessionId}`
                                                                                                );
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    )}
                                                                    {upcomingSession.length > 3 && (
                                                                        <div className="flex items-end justify-end mt-auto">
                                                                            <button
                                                                                className="rounded-lg bg-UIprimary px-3 py-1.5 text-base font-semibold text-white"
                                                                                onClick={() =>
                                                                                    this.props.history.push(
                                                                                        `${PATH.IM_PATIENT.APPOINTMENT}/${this.props.match.params.userId}`
                                                                                    )
                                                                                }
                                                                            >
                                                                                <i className="mr-2 far fa-arrow-right"></i>
                                                                                See all
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <div className="flex items-center justify-center text-white">
                                                                    No sessions found
                                                                </div>
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <div
                                                            className="overflow-x-auto"
                                                            id="recent"
                                                            role="tabpanel"
                                                            aria-labelledby="recent-tab"
                                                        >
                                                            {previousSession &&
                                                            previousSession.length ? (
                                                                <>
                                                                    {previousSession.map(
                                                                        (session, index) => (
                                                                            <div
                                                                                className="w-full p-3 mb-6 overflow-auto rounded-lg bg-card border-[#34373E] hover:bg-black/10 lg:overflow-hidden whitespace-nowrap"
                                                                                key={index}
                                                                            >
                                                                                <div className="sm:grid md:grid-cols-7 lg:gap-4 md:gap-24">
                                                                                    <div>
                                                                                        <p className="mb-1 text-sm text-white">
                                                                                            Session
                                                                                            Type
                                                                                        </p>
                                                                                        <SessionType
                                                                                            className="mb-3 truncate sm:mb-0 text-UInew"
                                                                                            sessionType={
                                                                                                session.sessionType
                                                                                            }
                                                                                            isFromDashboard={
                                                                                                true
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                    <div>
                                                                                        <p className="mb-1 text-sm text-white">
                                                                                            Owner
                                                                                            Name
                                                                                        </p>
                                                                                        <p
                                                                                            className="mb-3 text-base font-normal truncate text-UInew sm:mb-0"
                                                                                            title={
                                                                                                session.educatorName
                                                                                            }
                                                                                        >
                                                                                            {
                                                                                                session.educatorName
                                                                                            }
                                                                                        </p>
                                                                                    </div>
                                                                                    <div>
                                                                                        <p className="mb-1 text-sm text-white">
                                                                                            Date
                                                                                        </p>
                                                                                        <p className="mb-3 text-base font-normal text-UInew sm:mb-0">
                                                                                            {moment(
                                                                                                session.sessionStartDate
                                                                                            ).format(
                                                                                                'MMM DD, YYYY'
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div>
                                                                                        <p className="mb-1 text-sm text-white">
                                                                                            Time
                                                                                        </p>
                                                                                        <p className="mb-3 text-base font-normal text-UInew sm:mb-0">
                                                                                            {moment(
                                                                                                session.sessionStartDate
                                                                                            ).format(
                                                                                                'hh:mm A'
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div>
                                                                                        <p className="mb-1 text-sm text-white">
                                                                                            {
                                                                                                AppConfig
                                                                                                    .labels
                                                                                                    .channelName
                                                                                            }
                                                                                        </p>
                                                                                        <p className="mb-3 text-base font-normal truncate text-UInew sm:mb-0">
                                                                                            {session.subject
                                                                                                ? session.subject
                                                                                                : RESPONSE_CONSTANT.NOT_ASSIGNED}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div>
                                                                                        <p className="mb-1 text-sm text-white">
                                                                                            Element{' '}
                                                                                        </p>
                                                                                        <p className="mb-3 text-base font-normal truncate text-UInew sm:mb-0">
                                                                                            {session.subCategory
                                                                                                ? session.subCategory
                                                                                                : RESPONSE_CONSTANT.NOT_ASSIGNED}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="flex items-center justify-end mt-4 sm:mt-0 text-wrap">
                                                                                        <SessionStatusButton
                                                                                            className="w-full"
                                                                                            status={
                                                                                                session.sessionStatus
                                                                                            }
                                                                                            visitId={
                                                                                                session.sessionId
                                                                                            }
                                                                                            sessionType={
                                                                                                session.sessionType
                                                                                            }
                                                                                            navigateToDetailScreen={() => {
                                                                                                this.props.history.push(
                                                                                                    `${PATH.IM_PATIENT.WAITINGROOM}/${this.props.match.params.userId}/${session.sessionId}`
                                                                                                );
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    )}
                                                                    {previousSession.length > 3 && (
                                                                        <div className="flex items-end justify-end mt-auto">
                                                                            <button
                                                                                className="rounded-lg text-white px-3 py-1.5 font-semibold bg-UIprimary"
                                                                                onClick={() =>
                                                                                    this.props.history.push(
                                                                                        `${PATH.IM_PATIENT.APPOINTMENT}/${this.props.match.params.userId}`
                                                                                    )
                                                                                }
                                                                            >
                                                                                <i className="mr-2 far fa-arrow-right"></i>
                                                                                See all
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <div className="flex items-center justify-center text-white">
                                                                    No sessions found
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                    {/* <Modal
            isOpen={isModalOpen}
            className="fixed inset-0 z-50 flex items-center justify-center"
            contentLabel="Update Profile"
            ariaHideApp={false}
            overlayClassName="fixed inset-0 bg-black bg-opacity-50"
          >
            <div className="relative w-full max-w-lg max-h-screen p-2 overflow-y-auto bg-white rounded-lg shadow-lg sm:max-w-xl lg:max-w-2xl">
              <div className="px-2 py-2">
                <div className="flex items-center p-4 mb-4 text-yellow-800 border-l-4 border-yellow-400 rounded bg-yellow-50">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="flex-shrink-0 text-yellow-500"
                  >
                    <path
                      fill="currentColor"
                      d="M2.725 21q-.275 0-.5-.137t-.35-.363t-.137-.488t.137-.512l9.25-16q.15-.25.388-.375T12 3t.488.125t.387.375l9.25 16q.15.25.138.513t-.138.487t-.35.363t-.5.137zm1.725-2h15.1L12 6zM12 18q.425 0 .713-.288T13 17t-.288-.712T12 16t-.712.288T11 17t.288.713T12 18m0-3q.425 0 .713-.288T13 14v-3q0-.425-.288-.712T12 10t-.712.288T11 11v3q0 .425.288.713T12 15m0-2.5"
                    />
                  </svg>
                  <span className="ml-2 text-sm">
                    Updating your profile is optional, but without your contact
                    details you may miss important notifications.
                  </span>
                </div>

                <div className="mb-4">
                  <h3 className="text-lg font-medium text-gray-900">
                    Update Profile
                  </h3>
                </div>

                <p className="mb-6 text-sm text-gray-600">
                  Providing your contact info is optional. It enables SMS and
                  email notifications. Choosing not to update will not impact
                  your platform access.
                </p>

                <div className="flex flex-col gap-4 mb-8 sm:flex-row">
                  <div className="flex-1">
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      placeholder="Enter Email"
                      onChange={(event) => {
                        this.setState({
                          profileEmail: event.target.value,
                        });
                      }}
                      value={this.state.profileEmail}
                      disabled={!!userEmail}
                      className="block w-full px-3 py-2 mt-1 text-sm border border-gray-300 rounded-md shadow-sm focus:ring-yellow-500 focus:border-yellow-500 disabled:bg-gray-100"
                    />
                  </div>
                  <div className="flex-1">
                    <label
                      htmlFor="mobile"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Mobile Number
                    </label>
                    <input
                      type="tel"
                      id="mobile"
                      placeholder="Enter Mobile Number"
                      onChange={(event) => {
                        this.setState({
                          profileMobileNumber: event.target.value
                            .replace(/\D/g, "")
                            .slice(0, 10),
                        });
                      }}
                      value={this.state.profileMobileNumber}
                      disabled={!!userMobileNumber}
                      className="block w-full px-3 py-2 mt-1 text-sm border border-gray-300 rounded-md shadow-sm focus:ring-yellow-500 focus:border-yellow-500 disabled:bg-gray-100"
                    />
                  </div>
                </div>
                <hr class="border-t border-gray-300 my-6" />
                <div className="flex flex-col items-center gap-4 sm:flex-row sm:justify-between">
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      className="w-4 h-4 text-yellow-500 border-gray-300 rounded cursor-pointer focus:ring-yellow-400"
                      onClick={() => {
                        this.closeCancelationModal();
                        this.handleHideRemindMe("hide");
                      }}
                    />
                    <span className="ml-2 text-sm text-gray-600 cursor-default">
                      Don't show this message again
                    </span>
                  </div>
                  <div className="flex flex-col gap-4 sm:flex-row">
                    <button
                      type="button"
                      onClick={() => {
                        this.closeCancelationModal();
                        this.handleHideRemindMe("remind");
                      }}
                      className="px-4 py-2 text-sm font-medium border border-gray-500 rounded-md w-50 text-gray"
                    >
                      Remind Me Later
                    </button>
                    <button
                      type="button"
                      className="px-4 py-2 text-sm font-medium text-white rounded-md w-50 bg-primary"
                      onClick={this.submit}
                    >
                      Update Contact Information
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Modal> */}
                </main>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.UserReducer.userDetails,
        todaySession: state.DashBoardPatientReducer.todaySession,
        previousSession: state.DashBoardPatientReducer.previousSession,
        upcomingSession: state.DashBoardPatientReducer.upcomingSession,
        deactivateUserScreen: state.NetworkInState.deactivateUserScreen,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getDashboardDetails: (callback) => {
            dispatch(getDashboardDetails(callback));
        },
        getAppointmentDetails: (callback) => {
            dispatch(getAppointmentDetails(callback));
        },
        getStudentEducator: (values, callback) => {
            dispatch(getStudentEducator(values, callback));
        },
        getStudentEducatorSubject: (id, values, callback) => {
            dispatch(getStudentEducatorSubject(id, values, callback));
        },
        getStudentEducatorSubcategory: (values, callback) => {
            dispatch(getStudentEducatorSubcategory(values, callback));
        },
        showNotification: (values, callback) => {
            dispatch(showNotification(values, callback));
        },
        onDemandBook: (values, callBack) => {
            dispatch(postOndemandAppointment(values, callBack));
        },
        // addUserContactInformation: (valuse, callback) => {
        //   dispatch(addUserContactInformation(valuse, callback));
        // },
        // hideRemindMeLater: (data, callback) => {
        //   dispatch(hideRemindMeLater(data, callback));
        // },
    };
};

const ConnectedPatientDashBoard = connect(
    mapStateToProps,
    mapDispatchToProps
)(withLanguage(PatientDashBoard));

export default (props) => (
    <LanguageProvider>
        <ConnectedPatientDashBoard {...props} />
    </LanguageProvider>
);
